import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import BolPara from 'src/assets/images/bolParaBg.png';
import CoinHand from 'src/assets/images/coins-hand.png';
import Services from 'src/services/Services';
import HorizontalScroll from './components/HorizontalScroll';
import PartnerCircle from './components/PartnerCircle';

export default function BolParaEsnafMain() {
    const navigate = useNavigate();
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const [companies, setCompanies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleRedirectToApplications = () => {
        navigate(`/dashboard/bol-para-esnaf-applications`);
    };

    const getCompanies = () => {
        Services.GetBolParaCompanies(parsedUser.token)
            .then((res) => {
                let data = res.data.result.filter(x => x.status === "1" && x.totalCampaigns > 0)
                setCompanies(res.data.status ? data : []);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getCompanies();
    }, []);

    const itemList = companies.map((company) => (
        <PartnerCircle
            key={company.id}
            image={company.logo}
            name={company.title}
            token={parsedUser.token}
            companyID={company.companyID}
            company={company}
        />
    ));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
            {isLoading ? (
                <Box>
                    <CircularProgress />
                </Box>
            ) : (
                <Stack spacing={2} alignItems="flex-start" width="100%" maxWidth="600px">
                    <Box component="img" src={BolPara} alt="Bol Para" sx={{ width: '287px' }} />

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Box component="img" src={CoinHand} alt="coins" sx={{ width: 24, height: 24 }} />
                        <Typography variant="h6" sx={{ color: '#EE7F2B', fontWeight: '700' }}>
                            Bol Para <Typography component="span" sx={{ color: '#494D59' }}>Nedir?</Typography>
                        </Typography>
                    </Stack>

                    <Typography variant="body2" sx={{ color: '#64748B' }}>
                        Easy Point’in anlaşmalı olduğu markaların ürünlerini satarak ek gelir elde etmenizi sağlayan harika bir fırsattır. Günlük işlerinizi yaparken, bu ürünleri satışa sunarak ekstra para kazanabilirsiniz!
                    </Typography>

                    <Typography variant="subtitle1" sx={{ color: '#494D59', fontWeight: '700' }}>
                        Partner Markalarımız
                    </Typography>

                    <HorizontalScroll style={{ marginBottom: '66px' }} itemList={itemList} />

                    <Button variant="contained" color="primary" fullWidth onClick={handleRedirectToApplications}>
                        Başvuruları Görüntüle
                    </Button>
                </Stack>
            )}
        </Box>
    );
}
